$b.on('click', '.collapse-toggle', function() {
    $this = $(this);

    // Grab the collapse target
    let collapseTarget = $(this).attr('data-target');

    // Check for and assign active class of toggle
    if ($this.hasClass('is-active')) {
        $this.removeClass('is-active');
        $('#' + collapseTarget).addClass('collapsed');
    } else {
        $this.addClass('is-active');
        $('#' + collapseTarget).removeClass('collapsed');
    }
});

$b.on('click', '.js-close-panel', function(e) {
    $('.collapse-toggle').removeClass('is-active');
    $(this).closest('.collapse').addClass('collapsed');
});